export const QuotationEnquiriesTableFields = {
    VESSEL: "vesselName",
    ACTIONS: "actions",
    STATUS: "status",
    STATUS_FRIENDLY_NAME: "statusName",
    STATUS_DATE: "statusDate",
    QUOTATION_NUMBER: "quotationNumber",
    QUOTATION_DATE_FROM: "quotationDateFrom",
    QUOTATION_DATE_TO: "quotationDateTo",
    IMO: "imo",
    TOTAL_PRICE: "totalPrice",
    TOTAL_PRICE_SORT_FIELD: "totalPriceSortField",
    PORT: "port",
    COUNTRY: "country",
    INSPECTION_TYPE: "inspectionType",
    PRICE_DISCOUNT_PERCENTAGE: "pricingDetails.priceDiscountPercentage",
    PRICE_DISCOUNT_AMOUNT: "pricingDetails.priceDiscountAmount",
    EXTRAS_PRICE: "extrasPrice",
    VESSEL_TYPE: "vesselType",
    QUOTATION_DATE_SORT_FIELD: "quotationDateSortField",
    QUOTATION_DATE: "quotationDate",
    LOCATION: "location",
    STATUS_DATE_SORT_FIELD: "statusDateSortField",
    NAME_FILTER_FIELD: "vesselNameFilterField",
    QUOTATION_DATE_FILTER_FIELD: "quotationDateFilterField"
};
